<template>
  <div id class="fillcontain">
    <router-view></router-view>
  </div>
</template>

<script>
import "fontawesome";

/*export default {
  name: 'app'
}*/
import globalData from "@/common/global.js";
export default {
  name: "app",

  async created() {
	globalData.init();
  }
};
</script>


<style lang="less">
#ClCache{display:none;} /*工行插件导致网页向下滚动*/
@import "./style/common";
</style>


// WEBPACK FOOTER //
// src/App.vue